// @flow
import * as React from 'react';
import {
    Layer, Box, Heading, Button, Text,
} from 'grommet';
import styled from 'styled-components';


const ColoredButton = styled(Button)`
    border: none;
    background: ${(props) => props.backgroundColor};
    color: ${(props) => props.textColor};
    border: none;
    &:hover {
        box-shadow: none;
    }
    height: 32px;
`;

type Props = {
    message?: string | React.Node,
    title?: ?string | React.Node,
    actions: {
        [string]: {
            label: string | React.Node,
            type?: 'positive' | 'negative',
            callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => void,
            [string]: any,
        }
    },
    actionsAlign: string,
    position: string,
    size: string,
}


const MessageDialog = (props: Props) => {
    const {
        message, title, actions, position, actionsAlign, size,
    } = props;

    const getButtonStyle = (name) => {
        const {
            label, callback, type, ...rest
        } = actions[name];
        
        // This is the style for positive buttons, we apply it by default
        let backgroundColor = '#e2e6ac';
        let textColor = '#457f24';

        if (type === 'negative') {
            backgroundColor = '#ffb2b2';
            textColor = '#990000';
        }

        return (
            <ColoredButton
                label={label}
                onClick={callback}
                key={name}
                {...rest}
                backgroundColor={backgroundColor}
                textColor={textColor}
            />
        );
    };

    return (
        <Layer position={position} modal zIndex={1000}>
            <Box width={size} pad="small">
                {title && (
                    <Box flex={false} direction="row" justify="between" margin={{ bottom: 'small' }}>
                        <Heading level={5} margin="none">{title}</Heading>
                    </Box>
                )}
                <Text textAlign="center">
                    {message}
                </Text>
                <Box justify={actionsAlign} margin={{ top: 'small' }} direction="row" gap="small">
                    {Object.keys(actions).map((name) => getButtonStyle(name))}
                </Box>
            </Box>
        </Layer>
    );
};


MessageDialog.defaultProps = {
    title: null,
    message: null,
    actions: {},
    position: 'center',
    actionsAlign: 'center',
    size: 'medium',
};

export default MessageDialog;
